import { render } from "./IndexView.vue?vue&type=template&id=28633b8e&ts=true"
import script from "./IndexView.vue?vue&type=script&lang=ts"
export * from "./IndexView.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__